@if (loading) {
  <app-loader></app-loader>
}

<ol class="breadcrumb">
  <li class="breadcrumb-item active">Customers</li>

  <li class="breadcrumb-item">
    <a routerLink="/customers/create">
      <app-icon icon="plus" iconClass="button-icon"></app-icon> Add Customer
    </a>
  </li>
</ol>

<div class="row">
  <div class="col-xs-12">
    <p-table
      [value]="customers"
      selectionMode="single"
      [(selection)]="selectedCustomer"
      (onRowSelect)="onRowSelect($event)"
      (onRowUnselect)="null"
      [paginator]="true"
      [rows]="10"
      stateKey="state-session-customers"
      >
      <ng-template pTemplate="header">
        <tr>
          @for (key of keys; track key) {
            <th pSortableColumn="{{ key }}" [style.width]="tableConfig.columns[key].width">
              {{ tableConfig.columns[key].title }} <p-sortIcon field="{{ key }}"></p-sortIcon>
            </th>
          }
        </tr>
        <tr>
          @for (key of keys; track key) {
            <th style="width:22%">
              <p-columnFilter
                type="text"
                field="{{key}}"
                placeholder="{{tableConfig.columns[key].title}}"
                ariaLabel="Filter {{tableConfig.columns[key].title}}"
                />
              </th>
            }
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-customer>
          <tr [pSelectableRow]="customer">
            @for (key of keys; track key) {
              <td>{{ customer[key] }}</td>
            }
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
